import CategoriesWithIconsBlock from './categoriesWithIconsBlock'

export default CategoriesWithIconsBlock
